import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

export class SelectUrlProxyApply extends Component {
  static displayName = SelectUrlProxyApply.name;

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      name: props.name,
      requiredAPI: props.requiredAPI,
      options: [],
      local_net_id: '',
      local_unit_id: '',
      current_user_type: localStorage.getItem('login_user_type'),
      selectedUrl: props.selectedUrl, // 將selectedUrl設置為狀態
      parentName: props.parentName,
    };
  }


  componentDidMount() {
    this.loadData(this.props.selectnet, this.props.local_net_name, this.props.selectedUnitproxy, this.props.selecteduser);

  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectnet !== this.props.selectnet || prevProps.local_net_name !== this.props.local_net_name || prevProps.selecteduser !== this.props.selecteduser) {
      this.loadData();
    }
  }

  loadData() {
    this.setState({ options: [] });
    let apiUrl = api_url + this.state.requiredAPI;
    let { parentName } = this.props;
    const formData = new FormData();
    if (parentName === 'superS') {
      formData.append("local_net_id", this.props.selectnet);
      formData.append("local_net_name", this.props.local_net_name);
      formData.append("local_unit_id", this.props.selectedUnitproxy);
      formData.append("user_name", this.props.selecteduser);
    }
    else if (parentName === 'superM') {
      formData.append("local_net_id", this.props.selectnet);
      formData.append("local_net_name", this.props.local_net_name);
      formData.append("local_unit_id", this.props.selectedUnitproxy);
      formData.append("user_name", this.props.selecteduser);
    }
    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail];
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        this.setState({ options: rows });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
  handleSelectUrlProxyChange = (event) => {
    const { name, value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedText = event.target.options[selectedIndex].text;
    const httpIndex = selectedText.indexOf('http');
    const url_addr = httpIndex >= 0 ? selectedText.substring(httpIndex) : '';
    console.log(value)
    this.setState({
      selectedName: url_addr
    }, () => {
      // console.log("已更新的selectedName狀態：", this.state.selectedName);
    });

    this.props.onChange({ target: { name, value, selectedName: url_addr } });
  };


  render() {
    return (
      <Input
        id={this.state.id}
        name={this.state.name}
        onChange={this.handleSelectUrlProxyChange}
        type='select'
        value={this.props.selectedUrl} // 使用 prop 設置選擇的值
      >
        <option key="0" value="">
          請選擇
        </option>
        {this.state.options.map(option => (
          <option key={option.id} value={option.id}>
            {option.url_name}-{option.url_addr}
          </option>
        ))}
      </Input>
    );
  }
}